/**
 * @flow
 * @format
 */

import React from 'react';
import FaRotateLeft from 'react-icons/lib/fa/rotate-left';
import { Button } from 'reactstrap';
import { pick } from 'lodash/fp';

import { createHTMLMarkup, deepDiffer } from '~/utils';

// import classes from './RevertInput.scss';

type PropsType = {
  className?: ?string,
  enable: boolean,
  onClick: Function,
  value: string | number | null,
};

export class RevertInput extends React.Component<PropsType, *> {
  props: PropsType; // eslint-disable-line react/sort-comp
  static defaultProps = {
    className: null,
  };

  shouldComponentUpdate(nextProps: PropsType) {
    const subProps = pick(['enable', 'value']);
    return deepDiffer(subProps(this.props), subProps(nextProps));
  }

  render() {
    const text = this.props.value === null ? 'N/A' : this.props.value;
    // const text = this.props.value;
    const string = createHTMLMarkup(`Recommended: [<span>${text}</span>]`);
    return (
      <Button
        className={this.props.className}
        color="link"
        size="sm"
        disabled={!this.props.enable}
        onClick={this.props.onClick}
      >
        {string} <FaRotateLeft />
      </Button>
    );
  }
}

export default RevertInput;



// WEBPACK FOOTER //
// ./src/components/RevertInput/RevertInput.js